var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#ozfslsv2pa)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5.063 3.418 3.418 5.063l5.087 5.087-.338.35H3.5v7h4.667L14 23.333v-7.688l4.877 4.877a7.832 7.832 0 0 1-2.544 1.295v2.403a10.43 10.43 0 0 0 4.212-2.042l2.392 2.392 1.645-1.645L5.063 3.418zm6.604 14.28-2.532-2.531H5.833v-2.334h3.302l1.027-1.026 1.505 1.505v4.386zM22.167 14c0 .957-.175 1.878-.479 2.73l1.785 1.785A10.424 10.424 0 0 0 24.5 14c0-4.993-3.488-9.17-8.167-10.232v2.404A8.173 8.173 0 0 1 22.167 14zM14 4.667 11.807 6.86 14 9.053V4.667zM19.25 14a5.25 5.25 0 0 0-2.917-4.702v2.089l2.894 2.893c.011-.093.023-.187.023-.28z",
  fill: "#626262"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "ozfslsv2pa"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h28v28H0z"
})));

function SvgVolumeOff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeOff);
export default __webpack_public_path__ + "static/media/volume_off.fefa2a47.svg";
export { ForwardRef as ReactComponent };